import { getTranslation } from '../../../../../utils/translations';
import translation from './translations';
var t = getTranslation(translation);
var applicantSalutationOptions = [
    { label: t.salutationMale, value: 'MR' },
    { label: t.salutationFemale, value: 'MRS' },
];
export default {
    applicantSalutationOptions: applicantSalutationOptions,
};
